module.exports = __webpack_public_path__ + "static/media/info_ttn.2d6b3c8f.svg";